import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { IhmDrawerButtonComponent } from './ihm-drawer-button.component';

@NgModule({
  imports: [CommonModule, MatSidenavModule, MatIconModule, MatButtonModule],
  declarations: [IhmDrawerButtonComponent],
  exports: [IhmDrawerButtonComponent]
})
export class IhmDrawerButtonModule {}
